var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-system multiline-ellipsis"},[_vm._v(" "+_vm._s(_vm.getOpType())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }